import { handleError } from "./error.helper";

const readHeader = (headers, key) => {
    if (!headers) return "";
    if (typeof headers.get === "function") {
        return headers.get(key) || "";
    }
    return headers[key] || headers[key.toLowerCase()] || headers[key.toUpperCase()] || "";
};

export const collectAuthHeaderToken = (response) => {
    const headers = response?.headers;
    const raw =
        readHeader(headers, "authorization") ||
        readHeader(headers, "Authorization") ||
        readHeader(headers, "x-auth-token") ||
        readHeader(headers, "X-Auth-Token");
    return String(raw || "")
        .replace(/^Bearer\s+/i, "")
        .trim();
};

export const handleResponse = (response) => {
    return new Promise((resolve, reject) => {
        if (!response) {
            reject({ error: "No response from server", code: 503 });
            return;
        }

        if (response.status < 300 && response.status >= 200) {
            resolve(response?.data || {});
        } else {
            reject(handleError(response));
        }
    });
};

/** Login: keep body + Authorization / x-auth-token response headers. */
export const handleLoginResponse = (response) => {
    return new Promise((resolve, reject) => {
        if (!response) {
            reject({ error: "No response from server", code: 503 });
            return;
        }

        if (response.status < 300 && response.status >= 200) {
            const headerToken = collectAuthHeaderToken(response);
            const data = response?.data;

            if (typeof data === "string" && data.trim()) {
                resolve({ token: data.trim(), headerToken: headerToken || data.trim() });
                return;
            }

            const body =
                data && typeof data === "object" && !Array.isArray(data) ? data : {};

            if (headerToken) {
                resolve({ ...body, headerToken, token: body.token || headerToken });
                return;
            }

            if (typeof data === "string") {
                resolve({ token: data });
                return;
            }

            resolve(body);
            return;
        }

        reject(handleError(response));
    });
};